import type { EDetectorType } from '@web/entities/measurement/model/enums/detector-type.enum.ts'
import type { EWindowType } from '@web/entities/measurement/model/enums/specter.enum.ts'

export const mapWindowsType: { [key in EWindowType]: string } = {
  HAMMING: 'Хэмминга',
  HANN: 'Ханна',
  BLACKMANHARRIS: 'Блэкмана-Харриса',
  FLATTOP: 'С плоской вершиной',
  TRIANGULAR: 'Треугольное'
} as const

export const windowsTypeOptions = Object.entries(mapWindowsType).map(
  ([key, label]) => ({
    value: key as EDetectorType,
    label
  })
)
